// Basic Bot Detection Script for Shopify
(function() {
    const BOT_SCORE_THRESHOLD = 0.5; // Adjust based on desired sensitivity
    const EVENT_CATEGORY = 'Bot Detection';
    const EVENT_ACTION = 'Suspected Bot';
    const EVENT_LABEL = 'Bot Score';

    function isLikelyBot() {
        // Simple heuristic checks

      console.log("Bot traccking started")
        const tooFast = (performance.now() < 1000); // Page load under 1s
        const noInteraction = !document.hasFocus();
        const headless = /HeadlessChrome/.test(navigator.userAgent);
        const suspiciousPlugins = navigator.plugins.length === 0;
        const rapidMouse = window.navigator.maxTouchPoints === 0 && (window.outerWidth - window.innerWidth > 100);

        // Fingerprinting (e.g., screen resolution anomalies)
        const unusualResolution = window.screen.width > 4000 || window.screen.height > 3000;

        // Basic score calculation (tweak weights as needed)
        let botScore = 0;
        botScore += tooFast ? 0.3 : 0;
        botScore += noInteraction ? 0.2 : 0;
        botScore += headless ? 0.3 : 0;
        botScore += suspiciousPlugins ? 0.2 : 0;
        botScore += rapidMouse ? 0.2 : 0;
        botScore += unusualResolution ? 0.2 : 0;

      console.log("botScore",botScore)
      
        return botScore;
    }

    function sendBotEvent(score) {
        console.log("sendBotEvent")
      // Send to Google Analytics (GA4 example)
        if (window.gtag) {
            gtag('event', EVENT_ACTION, {
                event_category: EVENT_CATEGORY,
                event_label: EVENT_LABEL,
                value: score,
                suspected_bot: score >= BOT_SCORE_THRESHOLD
            });
        }
    }

    // Run detection and report
    const botScore = isLikelyBot();
    if (botScore >= BOT_SCORE_THRESHOLD) {
        console.warn('[Bot Detection] Suspected bot detected with score:', botScore);
        sendBotEvent(botScore);
    }
})();
